import { render } from "./tpl_group.vue?vue&type=template&id=357e29fe&scoped=true"
import script from "./tpl_group.vue?vue&type=script&lang=js"
export * from "./tpl_group.vue?vue&type=script&lang=js"

import "./tpl_group.vue?vue&type=style&index=0&id=357e29fe&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357e29fe"],['__file',"src/views/wap/template/tpl_group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "357e29fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('357e29fe', __exports__)) {
    console.log('reload')
    api.reload('357e29fe', __exports__)
  }
  
  module.hot.accept("./tpl_group.vue?vue&type=template&id=357e29fe&scoped=true", () => {
    console.log('re-render')
    api.rerender('357e29fe', render)
  })

}


export default __exports__